import { ChevronDown, ChevronUp, Trash2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const base = "w-full bg-[#0F0F12] border border-white/10 focus:border-[#C5A059]/70 outline-none text-sm text-white px-3 transition-colors";

export const Field = ({ label, value, onChange, multiline, help, testid, placeholder, type = "text" }) => (
  <label className="block">
    <span className="block text-[0.68rem] uppercase tracking-[0.18em] text-[#A1A1AA] mb-2">{label}</span>
    {multiline ? (
      <textarea rows={3} value={value || ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className={`${base} py-2.5 min-h-[88px] resize-y`} data-testid={testid} />
    ) : (
      <input type={type} value={value || ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className={`${base} h-11`} data-testid={testid} />
    )}
    {help && <span className="block mt-1.5 text-xs text-[#71717A]">{help}</span>}
  </label>
);

export const Toggle = ({ label, checked, onChange, testid }) => (
  <label className="inline-flex items-center gap-3 cursor-pointer text-sm text-[#D4D4D8]">
    <Switch checked={!!checked} onCheckedChange={onChange} data-testid={testid} className="data-[state=checked]:bg-[#C5A059] data-[state=unchecked]:bg-white/15" />
    {label}
  </label>
);

export const ItemControls = ({ onUp, onDown, onDelete, testid }) => (
  <div className="flex items-center gap-1">
    <button type="button" onClick={onUp} aria-label="Mover para cima" className="h-9 w-9 flex items-center justify-center border border-white/10 hover:border-white/40 text-[#CBD5E1]" data-testid={`${testid}-up`}>
      <ChevronUp className="w-4 h-4" />
    </button>
    <button type="button" onClick={onDown} aria-label="Mover para baixo" className="h-9 w-9 flex items-center justify-center border border-white/10 hover:border-white/40 text-[#CBD5E1]" data-testid={`${testid}-down`}>
      <ChevronDown className="w-4 h-4" />
    </button>
    <button
      type="button"
      onClick={() => window.confirm("Remover este item? A alteração só vai ao site após publicar.") && onDelete()}
      aria-label="Remover"
      className="h-9 w-9 flex items-center justify-center border border-white/10 hover:border-red-400/60 text-red-300"
      data-testid={`${testid}-delete`}
    >
      <Trash2 className="w-4 h-4" />
    </button>
  </div>
);

export const TempBadge = () => (
  <span className="text-[0.6rem] uppercase tracking-[0.18em] px-2 py-1 border border-amber-400/40 text-amber-300 bg-amber-400/10">Ilustrativa — substituir</span>
);

export const Panel = ({ title, desc, children, actions }) => (
  <section className="border border-white/10 bg-[#0B0B0E] p-5 sm:p-7">
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h2 className="font-display text-2xl text-white">{title}</h2>
        {desc && <p className="mt-1 text-sm text-[#71717A] max-w-2xl">{desc}</p>}
      </div>
      {actions}
    </div>
    {children}
  </section>
);
